import { ONBOARDING_VIEWS } from 'onboarding-settings-client/constants/onboardingViews';
import { CMS_STARTER, MARKETING_STARTER, OPS_STARTER, SALES_STARTER, SERVICE_STARTER } from './urlConstants';
export const ONBOARDING_PARAM_TO_VIEWS = {
  [MARKETING_STARTER]: ONBOARDING_VIEWS.MARKETING,
  [SALES_STARTER]: ONBOARDING_VIEWS.SALES,
  [SERVICE_STARTER]: ONBOARDING_VIEWS.SERVICE,
  [CMS_STARTER]: ONBOARDING_VIEWS.CMS,
  [OPS_STARTER]: ONBOARDING_VIEWS.SALES
};